module.exports = __webpack_public_path__ + "media/images/meow_party-f4184f1550277dece5b3e4dc9811fa44.gif";